import { Component, inject, Renderer2, signal, ViewContainerRef, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { SidebarContent } from "./components/sidebar-content/sidebar-content";
import { iconsProvider } from './components/sidebar-icon-registry';
import { NgIcon } from '@ng-icons/core';
import { filter, map } from 'rxjs/operators';
import { GetGiftWithColleagueDialogComponent } from '../dashboard/my-packages/get-gift-with-colleague-dialog/get-gift-with-colleague-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AppLayoutService } from './app.layout.service';

@Component({
  selector: 'app-layout',
  standalone: false,
  providers: [
    iconsProvider,
    AppLayoutService
  ],
  styleUrls: ['./app.layout.scss'],
  templateUrl: './app.layout.html',
})
export class AppLayout {
  sidebarWidth = signal(280);
  dialogService = inject(MatDialog);
  viewContainerRef = inject(ViewContainerRef);
  appLayoutService = inject(AppLayoutService);
  elementRef = inject(ElementRef);

  ngOnInit() {
    this.updateCssVariables();
  }

  updateCssVariables() {
    const variableName = '--sidebar-width';
    const variableValue = `${this.sidebarWidth()}px`;
    this.elementRef.nativeElement.style.setProperty(variableName, variableValue);
  }

  public onGetGiftWithColleagueButtonClick(): void {
    GetGiftWithColleagueDialogComponent.open(this.dialogService, this.viewContainerRef);
  }
}
